export default __webpack_public_path__ + "static/media/samplePic.53b3426e.svg";